<script lang="ts" setup>
const layout = await useLayout();
const { HOSTING_IS_PRODUCTION: isProduction } = useRuntimeConfig().public;
</script>

<template>
  <footer v-if="layout" class="mt-6 bg-[#f3f1ec]">
    <div v-if="layout?.usps">
      <div class="container mx-auto py-10">
        <FooterUsps :data="layout.usps" />
      </div>
    </div>

    <div class="rounded-t-lg bg-neutral-500 text-white">
      <div class="container mx-auto py-10">
        <FooterMain :data="layout" />
      </div>
    </div>

    <div class="bg-[#503E3E] text-sm text-white">
      <div class="container mx-auto py-3">
        <FooterClosing :data="layout" />
      </div>
    </div>
    <div v-if="!isProduction" class="relative">
      <div class="absolute bottom-14 right-1 cursor-default opacity-50 hover:opacity-100">
        <ResponsiveSizeBadge />
      </div>
    </div>
  </footer>
</template>

<style scoped>
</style>
